import bizContext from 'src/components/biz-context';
import { getCurrentBizOp, getNewBizOp, getPrevBizOp, BizOp } from 'src/components/biz-op';
import clientContext from 'src/components/client-context';
import { IBaseEvent } from 'src/components/event-message';
import { BIZOP_TYPE, ERROR_TYPE, HB_EVENT_NAME, PAGE_START_TIME, RESOURCE_TYPE } from 'src/constant';
import EVENT_MSG_TYPE from 'src/constant/event-msg-type';
import converter from 'src/core/converter';
import reporter from 'src/core/reporter';
import { nav, win } from 'src/global';
import { fixDateValue, isOnline, setTimeoutIdle } from 'src/utils';
import getUniqueStr from 'src/utils/get-unique-str';
import { geErrorEventType } from 'src/utils/event';
import getResponseData from 'src/utils/get-response-data';
import { IHBReqEvent, WrapErrorEvent } from 'src/types/type';
import resourceXhr from 'src/components/resource-xhr';
import HB_FILTER_REQUEST from 'src/constant/filter-request';
import checkFixXhr from 'src/utils/check-fix-xhr';
import getErrorDetail from 'src/utils/get-error-detail';
import getFieldInfo from 'src/utils/get-fieldinfo';
import HB_FILTER_ERROR from 'src/constant/filter-error';
import CountEvent from 'src/components/count-event';
import safeInvoke from 'src/utils/safe-invoke';
import HB_STATUS from 'src/constant/hb-status';
import getErrorEventFromRequest from 'src/utils/get-error-event-from-request';
import filterCacheRes from 'src/components/filter-cache-res';
import { setCookie } from 'src/utils/cookies';
import { inpMonitor } from 'src/components/inp';
import { clsMonitor } from 'src/components/cls';

const REPORT_BATCH_COUNT = 40; // 批次上报的事件数量检测值
const noBizEventQueue: HBEventData[] = []; // 组装好的无业务操作关联的事件队列
const eventMessages: EventMessage[] = []; // 以业务操作单元组装好的事件消息列表
const waitReportMessages = []; // 待上报数据
let patrolTimer: any = 0; // 巡查定时器
const PATROL_TIME = 1 * 60 * 1000; // 巡查时间周期
const REPORT_LEGACY_LS_KEY = 'HB_WAIT_REPORT_MESSAGES';
let lastServiceCommonInfo: HBEventData = null;
let pageviewFinished = true; // 标记是否已收到pageview事件
let batchReportTimer = null; // 批量上报批次量达到时执行上报的延迟器
let isFirstReportFinished = false; // 是否首次上报完成
/**
 * 数据处理中心 流水线
 * 负责接收采集到的各类事件数据，加工组装，以及上报
 */
class Pipeline {
  oriEvents: IBaseEvent<any>[];
  hubbleMonitor: any;
  timer: { clear: () => void } | null; // work执行对应的定时器
  lastClickEvent: HBEventData<HBClick> | null;
  currentSid: string;
  pageViewBiz: BizOp;
  constructor() {
    const uba = win.uba;
    if(!uba || !uba.__instance) {
      hbLogger.warn('Hubble uba the initialization is not complete!');
      return;
    }
    this.oriEvents = [];
    this.hubbleMonitor = uba.__instance as any;
    this.hubbleMonitor.stocksBatchReport = (forceCloseBizOp?: boolean) => {
      if (forceCloseBizOp) this.forceCloseCurrentBizOp();
      this.batchReport();
    };
    this.currentSid = uba.getSid(true);
    this.lastClickEvent = null;
    this.initEvent();
    if (this.enableCollect()) {
      pageviewFinished = false;
      this.createPageViewBizOp();
      this.receiveLegacy();
    }

    // 初始化INP、CLS性能监控采集器
    const reportMetrics = (metric) => {
      if (metric && lastServiceCommonInfo) {
        this.pushQueue(null, [{
          ...lastServiceCommonInfo,
          en: HB_EVENT_NAME.PERF,
          eid: getUniqueStr(metric.finishTime),
          pkey: metric.name,
          pval: metric.value,
          attrs: metric,
        }]);
      }
    };
    inpMonitor.start(reportMetrics);
    clsMonitor.start(reportMetrics);
    // 首次上报逻辑
    setTimeout(() => {
      this.batchReport();
      isFirstReportFinished = true;
    }, 10000);
  }
  // 服务端时间 - 客户端时间
  get gapTime() {
    return this.hubbleMonitor?.gapTime || -1;
  }
  // get reportUrl() {
  //   return this.hubbleMonitor.reportUrl;
  // }
  initEvent() {
    let pageClose = () => {
      this.packPagecloseEvent({
        time: Date.now(),
        type: EVENT_MSG_TYPE.PAGECLOSE,
        data: [],
      });
      this.batchReport(true);
    };
    ['beforeunload', 'unload'].forEach(etype => {
      safeInvoke(win, win.addEventListener, etype, () => {
        if(pageClose) {
          pageClose();
        }
        pageClose = null;
      }, true);
    });
  }
  pushQueue(eMessage:EventMessage, events?: HBEventData[]) {
    if (eMessage) {
      eventMessages.push(eMessage);
    }
    if (events?.length > 0) {
      noBizEventQueue.push(...events);
    }
    const currentWaitReportEventCount = noBizEventQueue.length + eventMessages.reduce((p, c) => p + (c.content?.length || 1), 0)
    if (isFirstReportFinished && currentWaitReportEventCount > REPORT_BATCH_COUNT) {
      clearTimeout(batchReportTimer);
      batchReportTimer = setTimeout(() => {
        batchReportTimer = null;
        this.batchReport();
      }, 400);
    }
  }
  // 处理接收之前遗留未上报的存储在本地缓存中的待上报数据
  receiveLegacy() {
    try {
      const lastLegacy = JSON.parse(localStorage.getItem(REPORT_LEGACY_LS_KEY));
      localStorage.removeItem(REPORT_LEGACY_LS_KEY);
      if (lastLegacy instanceof Array && lastLegacy.length > 0) {
        waitReportMessages.push(...lastLegacy);
      }
    } catch (err) {
      // 错误异常数据，抛弃不做处理
    }
  }
  eventHandler(events: IBaseEvent<any>[]) {
    const curSid = win.uba?.getSid();
    // 当前无会话信息时，说明用户已长时间无交互操作，此时可认为休眠状态，期间采集的数据不在处理和上报，直到有新的会话开始
    if(curSid && this.enableCollect()) {
      this.currentSid = curSid;
      const evts = events.filter(oriEvent => this.filterEvent(oriEvent));
      this.oriEvents.push(...evts);
      if(this.timer) {
        this.timer.clear();
      }
      this.timer = setTimeoutIdle(() => {
        this.timer = null;
        this.startWork();
      });
    }
  }
  // 采集收集状态
  enableCollect() {
    if (this.hubbleMonitor.status !== HB_STATUS.RUNNING && !this.hubbleMonitor.reportDataListener) {
      return false;
    }
    return true;
  }
  createPageViewBizOp() {
    hbLogger.debug('createPageViewBizOp');
    // 创建一个业务操作
    const bizStartTime = PAGE_START_TIME;
    const pageViewBiz = getNewBizOp({
      bt: bizStartTime,
      btype: BIZOP_TYPE.PAGEVIEW,
      callback: this.handleBizOpCallback
    });
    this.pageViewBiz = pageViewBiz;
  }
  filterEvent(oriEvent: IBaseEvent) {
    let isEnabled = true;
    const type = oriEvent.type;

    // 未开启自动采集上报时，非手动上报类的过滤掉，不处理
    if (!this.hubbleMonitor.config.autoCollect && !oriEvent.isManual) {
      return false;
    }
    // 请求类过滤逻辑
    if(type === EVENT_MSG_TYPE.RESOURCE || type === EVENT_MSG_TYPE.XHR || type === EVENT_MSG_TYPE.FETCH) {
      const rurl = String(oriEvent.data.rurl || '');
      const requestFilter = this.hubbleMonitor?.config?.requestFilter;
      const filterArr = requestFilter instanceof Array
        ? [...HB_FILTER_REQUEST, ...requestFilter]
        : HB_FILTER_REQUEST;
      const isHit = filterArr.some(item => !!rurl.match(item));
      if (isHit) {
        isEnabled = false;
      };
      if(isEnabled && typeof requestFilter === 'function') {
        isEnabled = !!requestFilter(rurl);
      }

      if(!isEnabled) {
        hbLogger.debug('过滤请求', rurl);
      }
    }
    // console.error日志过滤逻辑
    if(type === EVENT_MSG_TYPE.CONSOLEERROR){
      const msg = String(oriEvent.data.message || '');
      const filterError = HB_FILTER_ERROR;
      const isHit = filterError.some(item => !!msg.match(item));
      if (isHit) {
        isEnabled = false;
      };
      if(!isEnabled) {
        hbLogger.debug('过滤错误', msg);
      }
    }

    return isEnabled;
  }
  // 执行处理当前原始事件队列中的数据
  async startWork() {
    const curOriEvents = this.oriEvents.splice(0);
    for (const item of curOriEvents) {
      switch (item.type) {
      case EVENT_MSG_TYPE.JSERROR:
      case EVENT_MSG_TYPE.UNHANDLEDREJECTION:
      case EVENT_MSG_TYPE.CONSOLEERROR:
        await this.packErrorEvent(item);
        break;
      case EVENT_MSG_TYPE.CLICK:
        await this.packClickEvent(item);
        break;
      case EVENT_MSG_TYPE.RESOURCE:
        await this.packResourceEvent(item);
        break;
      case EVENT_MSG_TYPE.PAGEVIEW:
        await this.packPageviewEvent(item);
        break;
      case EVENT_MSG_TYPE.XHR:
      case EVENT_MSG_TYPE.FETCH:
        await this.packRequsetEvent(item);
        break;
      case EVENT_MSG_TYPE.CUSTOM:
      case EVENT_MSG_TYPE.OTHER:
        await this.packOtherEvent(item);
        break;
      case EVENT_MSG_TYPE.COUNT:
        await this.packCountEvent(item);
        break;
      case EVENT_MSG_TYPE.BIZOP:
        await this.packCustomBizOp(item);
        break;
      default:
        break;
      }
    }
  }
  // 服务浏览业务操作事件
  serviceViewEvent(ret: HBEventData) {
    inpMonitor.reset();
    clsMonitor.reset();
    lastServiceCommonInfo = ret;
    this.pushQueue({
      header: {
        ...ret,
        timing: undefined,
        ba: ret.servicename || ret.ptit,
        bid: getUniqueStr(ret.evt),
        btype: BIZOP_TYPE.YPAGEVIEW,
        bt: fixDateValue(ret.evt),
        bte: fixDateValue(ret.evt),
      },
      content: [
        {
          en: HB_EVENT_NAME.YPAGEVIEW,
          eid: getUniqueStr(ret.evt),
        }
      ],
    });
    win.uba?.reactPerfMonitor?.resetMetrics?.();
  }
  async getEventCommonInfo(fields: {en: string, evt: number, eid: string }) {
    try {
      const { appid, tid } = this.hubbleMonitor.config;
      const ret = {
        v: SDK_VERSION,
        sdkid: win.uba?.sdkid,
        jt: 'web',
        en: fields.en,
        eid: fields.eid,
        evt: fixDateValue(fields.evt),
        appid: appid || tid, // appid不存在时，默认tid，友云音兼容考虑
        tid,
        sid: this.currentSid,
      } as HBEventData;
      const appBizData = await bizContext(this.hubbleMonitor.config).catch((err) => {
        hbLogger.error('获取业务上下文数据异常(getBizData)', err);
        return {};
      });
      const clientData = clientContext();
      clientData.tgap = this.gapTime;
      Object.assign(ret, appBizData, clientData);
      // 记录当前最新事件eid BPR录制结束时会读取作为标识使用
      setCookie('UBA_LAST_EID', fields.eid);
      // servicecode发生变化时，触发一次服务浏览事件
      //
      if (pageviewFinished && lastServiceCommonInfo?.servicecode !== ret.servicecode) {
        this.serviceViewEvent(ret);
      }
      return ret;
    } catch (error) {
      hbLogger.debug('获取业务上下文数据异常(getEventCommonInfo)', error);
      return {};
    }
  }
  // 组装JS错误事件
  async packErrorEvent(oEvent: IBaseEvent) {
    const err = oEvent.data as WrapErrorEvent;
    const hbEvent = await this.getEventCommonInfo({
      en: HB_EVENT_NAME.ERROR,
      eid: getUniqueStr(new Date(oEvent.time)),
      evt: oEvent.time,
    });
    if (oEvent.type === EVENT_MSG_TYPE.UNHANDLEDREJECTION) {
      hbEvent.et = ERROR_TYPE.PromiseError;
    }
    if (oEvent.type === EVENT_MSG_TYPE.JSERROR) {
      hbEvent.et = geErrorEventType(err);
    }
    if (oEvent.type === EVENT_MSG_TYPE.CONSOLEERROR) {
      hbEvent.et = ERROR_TYPE.ConsoleError;
    }
    if (hbEvent.et === ERROR_TYPE.ReactError) {
      const mat = err.message.match(/Minified React error #(\d+)/i);
      hbEvent.ec = 'E04998';
      if (mat && mat[1]) {
        if (['31', '185', '130'].includes(mat[1])) {
          hbEvent.ec = 'E04999';
        }
        hbEvent.attrs = Object.assign({}, hbEvent.attrs, { RECODE: mat[1] });
      }
    }
    const errDetail = getErrorDetail(err);
    hbEvent.msg = errDetail.message;
    hbEvent.stk = errDetail.stack;
    hbEvent.fn = errDetail.filename;
    hbEvent.lno = errDetail.lineno;
    hbEvent.cno = errDetail.colno;
    hbEvent.ec = hbEvent.ec || errDetail.errorCode || 'E00000';
    hbEvent.cnt = 1;
    if(hbEvent.et === ERROR_TYPE.ResourceError) {
      const targetNode = err.target;
      // @ts-ignore
      const resSrc = targetNode?.src || targetNode?.href;
      hbEvent.fn = hbEvent.rurl = hbEvent.fn || resSrc;
      hbEvent.msg = hbEvent.msg || '资源加载错误';
      hbEvent.ec = 'E01005';
    }
    if(/localhost|chrome-extension/.test(hbEvent.stk)) {
      hbLogger.debug('过滤错误', hbEvent);
      return;
    }

    // 当前存在待关联的业务操作，放入业务操作内处理
    const currentBizOp = getCurrentBizOp();
    if(currentBizOp && hbEvent.evt >= currentBizOp.data.bt) {
      currentBizOp.push(hbEvent);
    } else {
      this.pushQueue(null, [hbEvent]);
    }
  }
  // 组装PV事件
  async packPageviewEvent(oEvent: IBaseEvent) {
    try {
      const pData = oEvent.data;
      const hbEvent = await this.getEventCommonInfo({
        en: HB_EVENT_NAME.PAGEVIEW,
        eid: getUniqueStr(new Date(oEvent.time)),
        evt: oEvent.time,
      });

      Object.assign(hbEvent, pData);
      if (this.pageViewBiz) {
        this.pageViewBiz.push(hbEvent);
        this.serviceViewEvent(hbEvent);
      }
      pageviewFinished = true;
    } catch (error) {
      hbLogger.error('组装pageview事件异常', error);
    }
  }
  async packPagecloseEvent(oEvent:IBaseEvent) {
    try {
      const hbEvent = await this.getEventCommonInfo({
        en: HB_EVENT_NAME.PAGECLOSE,
        eid: getUniqueStr(new Date(oEvent.time)),
        evt: oEvent.time,
      });
      this.pushQueue(null, [hbEvent]);
    } catch (error) {
      hbLogger.error('组装pageclose事件异常', error);
    }
  }
  // 组装资源加载事件
  async packResourceEvent(oEvent: IBaseEvent) {
    try {
      const oData: HBRequestInfo = oEvent.data;
      const hbEvent = await this.getEventCommonInfo({
        en: HB_EVENT_NAME.REQUEST,
        eid: getUniqueStr(new Date(oEvent.time)),
        evt: oEvent.time,
      });

      Object.assign(hbEvent, oData);
      const currentBizOp = getCurrentBizOp();
      if(currentBizOp && hbEvent.evt >= currentBizOp.data.bt) {
        currentBizOp.push(hbEvent);
      } else {
        this.pushQueue(null, [hbEvent]);
      }
    } catch (error) {
      hbLogger.error('组装Resource事件异常', error);
    }
  }
  // 组装请求事件
  async packRequsetEvent(oEvent: IBaseEvent<IHBReqEvent>) {
    try {
      const hbEvent = oEvent.data;
      const hbEventBase = await this.getEventCommonInfo({
        en: HB_EVENT_NAME.REQUEST,
        eid: getUniqueStr(new Date(oEvent.time)),
        evt: oEvent.time,
      });

      // 与request的重复匹配和关联以及部分字段的补充，必须等响应完成与关联上之后才能处理，
      // 故放入到业务关联中或无业务的事件队列中处理。
      // txid字段处理填充
      Object.assign(hbEvent, hbEventBase, { txid: hbEventBase.eid });

      const currentBizOp = getCurrentBizOp();
      if(currentBizOp && hbEvent.evt >= currentBizOp.data.bt) {
        currentBizOp.push(hbEvent);
      } else {
        this.pushQueue(null, [hbEvent]);
      }
    } catch (error) {
      hbLogger.error('组装Requset事件异常', error);
    }
  }
  // 组装用户点击事件
  async packClickEvent(oEvent: IBaseEvent) {
    try {
      const clickEvent = oEvent.data;
      const hbEvent = await this.getEventCommonInfo({
        en: HB_EVENT_NAME.CLICK,
        eid: getUniqueStr(new Date(oEvent.time)),
        evt: oEvent.time,
      });
      const clickInfo = {
        ...clickEvent,
        attrs: {
          ...hbEvent.attrs,
          ...clickEvent.attrs,
        },
        leid: this.lastClickEvent?.eid,
        _lastClickEvent: this.lastClickEvent,
      };
      Object.assign(hbEvent, clickInfo);
      if(clickEvent.fieldid) {
        const filedInfo = getFieldInfo(clickEvent.fieldid);
        if(filedInfo) {
          Object.assign(hbEvent, filedInfo);
        }
      }

      // 1. 页面加载过程中点击事件也放入pageview对应的业务操作中
      //    因为目前没有很好的办法可以区分，只能先放进一个里面
      // 2. 业务自定义类型的业务操作例外，生命周期的开始和结束由业务决定
      const currentBizOp = getCurrentBizOp();
      if(currentBizOp?.bType === BIZOP_TYPE.PAGEVIEW || /^[1-9]\d+$/.test(currentBizOp?.bType)) {
        if (hbEvent.evt >= currentBizOp.data.bt) {
          currentBizOp.push(hbEvent);
        } else {
          this.pushQueue(null, [hbEvent]);
        }
      } else {
        // 创建一个业务操作
        const newBizOp = getNewBizOp({
          bt: oEvent.time,
          btype: BIZOP_TYPE.CLICK,
          callback: this.handleBizOpCallback,
        });
        newBizOp.push(hbEvent);
      }
      this.lastClickEvent = hbEvent;
    } catch (error) {
      hbLogger.error('组装Click事件异常', error);
    }
  }
  // 自定义业务操作事件处理
  async packCustomBizOp(oEvent: IBaseEvent) {
    const { ba, endBizOp, timeout, btype } = oEvent.data;
    // 创建一个业务操作
    const newBizOp = getNewBizOp({
      bt: oEvent.time,
      btype: /^[1-9]\d+$/.test(btype) ? btype : BIZOP_TYPE.SINGLE_POINT,
      ba,
      dtxt: ba,
      callback: this.handleBizOpCallback,
    });
    hbLogger.info('自定义业务操作开始', newBizOp.data.bid, ba);
    const startEvent = await this.getEventCommonInfo({
      en: 'YCustomBizOpStart',
      eid: getUniqueStr(oEvent.time),
      evt: oEvent.time,
    });
    newBizOp.push(startEvent);
    endBizOp.then((t: number) => {
      // 延迟丢入宏任务队列执行，避免业务操作过快时且中间无宏任务，可能导致抓到的请求关联时，业务操作已关闭，因抓到请求事件后是丢入到宏任务等待处理的
      setTimeout(async () => {
        const evt = t || oEvent.time + timeout;
        const endEvent = await this.getEventCommonInfo({
          en: 'YCustomBizOpEnd',
          eid: getUniqueStr(evt),
          evt,
        });
        newBizOp.push(endEvent);
        newBizOp.closeBiz(evt);
        hbLogger.info('自定义业务操作结束', newBizOp.data.bid, ba);
      }, 1);
    });
  }
  // 其他类型事件，包括主动上报的自定义事件
  async packOtherEvent(oEvent: IBaseEvent) {
    try {
      const { en, attrs, ...otherData } = oEvent.data;
      const hbEvent = await this.getEventCommonInfo({
        en: en,
        eid: getUniqueStr(new Date(oEvent.time)),
        evt: oEvent.time,
      });
      hbEvent.attrs = {
        ...hbEvent.attrs,
        ...attrs,
      };
      if(oEvent.type !== EVENT_MSG_TYPE.CUSTOM) {
        Object.assign(hbEvent, otherData);
      }

      // 当前存在待关联的业务操作
      const currentBizOp = getCurrentBizOp();
      if(currentBizOp && hbEvent.evt >= currentBizOp.data.bt) {
        currentBizOp.push(hbEvent);
      } else {
        this.pushQueue(null, [hbEvent]);
      }
    } catch (error) {
      hbLogger.error('组装其他类型事件异常', error);
    }
  }
  async packCountEvent(oEvent: IBaseEvent<{ecid: string; ecbiz?: string}>) {
    // const { ecid, ecbiz } = oEvent.data;
    const hbEvent = await this.getEventCommonInfo({
      en: HB_EVENT_NAME.COUNT,
      eid: getUniqueStr(new Date(oEvent.time)),
      evt: oEvent.time,
    });
    hbEvent.attrs = { ...hbEvent.attrs, firstEvt: hbEvent.evt };
    Object.assign(hbEvent, {
        cnt: 1,
        ...oEvent.data,
    });
    // 计数统计事件，针对相同的ecid&ecbiz只记录首次事件的公共上下文信息，每次消费及上报后，将重新记录首次
    CountEvent.count(hbEvent);
  }
  // 业务操作关闭时处理逻辑
  handleBizOpCallback = (hbEvents: HBEventData[], isValid: boolean) => {
    hbLogger.debug('handleBizOpCallback', hbEvents, isValid);
    if (hbEvents && hbEvents.length > 0) {
      if (isValid) {
        const eventMessage = converter(filterCacheRes(hbEvents));
        if (eventMessage) {
          this.pushQueue(eventMessage, []);
        }
      } else {
        this.pushQueue(null, hbEvents);
      }
    }
  }
  // 强制关闭当前业务操作，同步捞取所有事件供监听器消费
  forceCloseCurrentBizOp() {
    // 先关闭被替换的上一个业务操作（其中包含用户真正关心的数据）
    let bizOp = getPrevBizOp();
    if (bizOp) bizOp.forceClose();
    // 再关闭当前业务操作（录制结束动作触发的空业务操作）
    bizOp = getCurrentBizOp();
    if (bizOp) bizOp.forceClose();
  }
  // 巡查上报，避免长时间事件积攒量较少而迟迟无法上报
  patrolReport() {
    if (!batchReportTimer) {
      patrolTimer = setTimeout(() => {
        patrolTimer = null;
        this.batchReport();
      }, PATROL_TIME);
    }
  }
  // 执行一次批次上报
  batchReport(isEnd?: boolean) {
    try {
      clearTimeout(patrolTimer);
      clearTimeout(batchReportTimer);
      const batchMessages = eventMessages.splice(0);
      const noBizMessage = converter(this.noBizEventCompleta());
      const countEvents = converter(CountEvent.consume(isEnd));

      if(noBizMessage) {
        batchMessages.push(noBizMessage);
      }
      if(countEvents) {
        batchMessages.push(countEvents);
      }

      if(batchMessages.length > 0) {
        waitReportMessages.push(...batchMessages);
      }
      if(waitReportMessages.length > 0 && isOnline()) {
        const todoMessages = waitReportMessages.splice(0);
        if(this.hubbleMonitor.reportDataListener) {
          this.hubbleMonitor.reportDataListener(todoMessages);
        }
        if(this.hubbleMonitor.status === HB_STATUS.RUNNING) {
          hbLogger.debug('batchReport', performance.now(), todoMessages.length);
          reporter(this.hubbleMonitor.reportUrl, todoMessages);
        }
      }
      if(isEnd) {
        if(waitReportMessages.length > 0) {
          localStorage.setItem(REPORT_LEGACY_LS_KEY, JSON.stringify(waitReportMessages));
          waitReportMessages.splice(0);
        }
      }
    } catch (error) {
      hbLogger.error('batchReport异常', error);
    }
    if (!isEnd) {
      this.patrolReport();
    }
  }
  /*** 非业务操作类事件处理 ***/
  // 1. 过滤未完成的异步事件
  // 2. 合并相同异步事件
  // 3. 处理补充response数据
  noBizEventCompleta(): HBEventData[] {
    const noBizEvents = filterCacheRes(noBizEventQueue.splice(0));
    const [doneEvents, waitEvents] = noBizEvents.reduce((p, c) => {
      if((<IHBReqEvent>c)._wait) {
        p[1].push(c);
      } else {
        p[0].push(c);
      }
      return p;
    }, [[], []] as HBEventData[][]);
    this.pushQueue(null, waitEvents);

    const errEvent: HBEventData[] = [];
    doneEvents.filter((item) => item.rtype === RESOURCE_TYPE.XHR).forEach(item => {
      const err = item._err as any;
      const same = resourceXhr.findSame(item);
      if(same) {
        item.rtiming = same.rtiming;
      }
      Object.assign(item, getResponseData(item as IHBReqEvent));
      item.rtype = checkFixXhr(item);
      if(err) {
        errEvent.push(getErrorEventFromRequest(item));
      }
    });
    if (errEvent.length > 0) {
      doneEvents.push(...errEvent);
    }
    return doneEvents;
  }
}
export default Pipeline;
